// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"827ce0c6","842":"6ec021b2","851":"80150f5f"}[chunkId] + ".chunk.js";
};